import getSearchParams from './getSearchParams';

const UTM_STORAGE_KEY = 'utm_data';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

function detectUtmSource() {
    const referrer = document.referrer;
    if (!referrer) return null;
    try {
        const referrerHost = new URL(referrer).hostname;
        if (!referrerHost || referrerHost === window.location.hostname) return null;
        if (/(^|\.)google\./.test(referrerHost)) return 'google';
        if (/(^|\.)bing\./.test(referrerHost)) return 'bing';
        if (/(^|\.)facebook\./.test(referrerHost)) return 'facebook';
        if (/(^|\.)yahoo\./.test(referrerHost)) return 'yahoo';
        return null;
    } catch (err) {
        return null;
    }
}

export function getStoredUtm() {
    try {
        const raw = sessionStorage.getItem(UTM_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        return null;
    }
}

export function captureUtmParams() {
    if (getSearchParams('utm_source')) {
        const params = UTM_KEYS.reduce((acc, key) => {
            acc[key] = getSearchParams(key) || '';
            return acc;
        }, {});
        sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(params));
        return;
    }
    if (getStoredUtm()) return;
    const detectedSource = detectUtmSource();
    if (detectedSource) {
        sessionStorage.setItem(
            UTM_STORAGE_KEY,
            JSON.stringify({ utm_source: detectedSource, utm_medium: 'website', utm_campaign: '', utm_content: '' })
        );
    }
}

export function chainUtmMedium(context) {
    const stored = getStoredUtm();
    if (!stored) return;
    const segments = stored.utm_medium ? stored.utm_medium.split('-') : [];
    if (segments.includes(context)) return;
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify({ ...stored, utm_medium: [...segments, context].join('-') }));
}

export function getUtmForRequest() {
    const stored = getStoredUtm();
    return UTM_KEYS.reduce((acc, key) => {
        acc[key] = (stored && stored[key]) || getSearchParams(key) || '';
        return acc;
    }, {});
}
